import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModal } from 'features/modal/modalSlice';
import { contentLocked, contentPushed } from 'features/layout/features/content/actions';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { useLockContentControl } from 'features/layout/grid-panel/controls/GridPanelLockControl/useLockContentControl';

const LockContentConfirmation = () => {
  const { t } = useTranslation('modals');

  const dispatch = useAppDispatch();

  const { data } = useAppSelector(selectActiveModal);

  const { canLockContent } = useLockContentControl();

  const shouldClose = !canLockContent;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('lockContentConfirm'));
    }
  }, [shouldClose, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('lockContentConfirm'));
  };

  const handleConfirm = () => {
    if (data.action === 'push') {
      dispatch(contentPushed());
    } else {
      dispatch(contentLocked());
    }

    dispatch(closeModal('lockContentConfirm'));
  };

  const titleKey = data.action === 'push' ? 'push_confirm.title' : 'lock_confirm.title';
  const descriptionKey =
    data.action === 'push' ? 'push_confirm.description' : 'lock_confirm.description';
  const btnOkKey =
    data.action === 'push' ? 'push_confirm.btn_ok_label' : 'lock_confirm.btn_ok_label';

  return (
    <ConfirmationDialog
      open={!shouldClose}
      cancelText={t('lock_confirm.btn_cancel_label')}
      title={t(titleKey)}
      description={t(descriptionKey)}
      okText={t(btnOkKey)}
      onCancel={handleCancel}
      onOk={handleConfirm}
      hideCloseButton
      preventClose
    />
  );
};

export default LockContentConfirmation;
